import { subDays } from 'date-fns';
import * as dotProp from 'dot-prop-immutable';
import { Action } from 'typescript-fsa';

import { createReducer } from '@topconagriculture/frontend-utils';

import { endOfDay, startOfDay } from './../../../core/helpers/utils/scalarUtils';
import { SelectedState } from '../../selected/selected.reducer';
import { setSelectedCalendar } from './appReports.actions';

export type AppReportsState = {
  readonly calendar: { activePeriod: 'from' | 'to' | undefined; from: Date | undefined; to: Date | undefined };
};

export const initialState: AppReportsState = {
  calendar: { activePeriod: undefined, from: subDays(startOfDay(new Date()), 14), to: endOfDay(new Date()) },
};

const appReportsReducer = createReducer(initialState, {
  [setSelectedCalendar.type]: (
    state: SelectedState,
    action: Action<{ activePeriod: 'from' | 'to' | undefined; from: Date; to: Date }>,
  ) => {
    action.payload.from = startOfDay(action.payload.from);
    action.payload.to = endOfDay(action.payload.to);

    return dotProp.set(state, 'calendar', action.payload);
  },
});

export default appReportsReducer;
